var exports = {
  "K": "IconButton__fFTwBu",
};

module.exports = exports;
